var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5C11.7348 12.5 11.4804 12.3946 11.2929 12.2071C11.1054 12.0196 11 11.7652 11 11.5C11 11.2348 11.1054 10.9804 11.2929 10.7929C11.4804 10.6054 11.7348 10.5 12 10.5C12.2652 10.5 12.5196 10.6054 12.7071 10.7929C12.8946 10.9804 13 11.2348 13 11.5C13 11.7652 12.8946 12.0196 12.7071 12.2071C12.5196 12.3946 12.2652 12.5 12 12.5ZM12 12.5V15M12.0001 3.5C14.3359 5.56658 17.3846 6.64257 20.5001 6.5C20.9537 8.04302 21.0925 9.66147 20.9082 11.2592C20.7239 12.8569 20.2204 14.4013 19.4275 15.8005C18.6346 17.1998 17.5685 18.4254 16.2925 19.4045C15.0166 20.3836 13.5569 21.0962 12.0001 21.5C10.4433 21.0962 8.98356 20.3836 7.70762 19.4045C6.43169 18.4254 5.36559 17.1998 4.57267 15.8005C3.77976 14.4013 3.27621 12.8569 3.09195 11.2592C2.9077 9.66147 3.04649 8.04302 3.50008 6.5C6.61561 6.64257 9.66425 5.56658 12.0001 3.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.b3fe0fdfbb676cc9160c0b26472369b2.svg";
export { ForwardRef as ReactComponent };